import React, { useState, useEffect } from "react";
import PageHeader from "../../Components/Customer/PageHeader";
import SimpleInput from "../../Components/SimpleInput";
import { useForm, Controller } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookSquare,
  faInstagram,
  faLinkedin,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import SelectDropdown from "src/Components/GlobalComponents/SelectDropdown";
import { IDropDownArray } from "src/types/GlobalInterfaces";
import PrimaryBtn from "src/Components/GlobalComponents/primaryBtn";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import { setUserDetails } from "src/Store/reducer";
import { AppDispatch, RootState } from "@store/store";
import { customer, phoneNumberRegex } from "src/lib/constans";
import PreviewProfileButton from "src/Components/Customer/PreviewProfileButton";
import { cityList } from "src/Config/CityList";
import CustomWebsiteDropdown from "src/Components/GlobalComponents/Widget/CustomWebsiteDropdown";
import { validateAndFilterPhoneNumber } from "src/helpers/helperFunctions";
interface FormValues {
  firstName: string;
  lastName: string;
  date: string;
  gender: string;
  mobile: string;
  address: string;
  city: string;
  headLine: string;
  facebookLink: string;
  linkedinLink: string;
  instagramLink: string;
  whatsappLink: string;

  [key: string]: any;
}

const EditProfile: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { userDetails } = useSelector((store: RootState) => store.appReducer);

  const genderList: IDropDownArray[] = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
  ];

  const [isLoader, setIsLoader] = useState<boolean>(false);

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues: {
      firstName: "",
      lastName: "",
      date: "",
      gender: "",
      mobile: "",
      address: "",
      city: "",
      headLine: "",
      facebookLink: "",
      linkedinLink: "",
      instagramLink: "",
      whatsappLink: "",
    },
  });

  // API_CALL: API call for customer edit profile
  const onSubmit = async (data: FormValues) => {
    setIsLoader(true);
    const { res, err } = await httpRequest<FormValues>({
      method: "put",
      path: "/doctors/profile-edit",
      params: data,
    });
    if (res) {
      const { message = "", doctorEdit } = res;
      toast("Profile updated successfully", { type: "success" });
      dispatch(setUserDetails(doctorEdit)); // set data in redux store
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  useEffect(() => {
    setValue("firstName", userDetails?.firstName);
    setValue("lastName", userDetails?.lastName);
    setValue("date", moment(userDetails?.date).format("YYYY-MM-DD"));
    setValue("gender", userDetails?.gender);
    setValue("mobile", userDetails?.mobile);
    setValue("address", userDetails?.address);
    setValue("city", userDetails?.city);
    setValue("headLine", userDetails?.headLine);
    setValue("facebookLink", userDetails?.facebookLink);
    setValue("instagramLink", userDetails?.instagramLink);
    setValue("linkedinLink", userDetails?.linkedinLink);
    setValue("whatsappLink", userDetails?.whatsappLink);
  }, [userDetails]);

  return (
    <>
      {/* Page header for edit profile */}
      <PageHeader
        title="Edit Profile"
        isButton={true}
        ButtonComponent={PreviewProfileButton}
      />
      <div className="parent-box">
        <h2 className='title-heading font-Poppins-SemiBold font-size-20px mb-3'>Edit Bio</h2>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-3">
            <Controller
              name="firstName"
              control={control}
              rules={{ required: "First Name is required" }}
              render={({ field }) => (
                <SimpleInput
                  isLabel={true}
                  labelText="First Name"
                  type="text"
                  id="edit-profile-first-name"
                  extraStyle={{ borderColor: "#00A297", marginBottom: 0 }}
                  readOnly={true}
                  {...field}
                />
              )}
            />
            {errors.firstName && (
              <p className="font-size-14px font-Poppins-Regular text-[#ff0000]">
                {errors.firstName.message}
              </p>
            )}
          </div>
          <div className="mb-3">
            <Controller
              name="lastName"
              control={control}
              rules={{ required: "Last Name is required" }}
              render={({ field }) => (
                <SimpleInput
                  isLabel={true}
                  labelText="Last Name"
                  type="text"
                  id="edit-profile-last-name"
                  extraStyle={{ borderColor: "#00A297", marginBottom: 0 }}
                  {...field}
                  readOnly={true}
                />
              )}
            />
            {errors.lastName && (
              <p className="font-size-14px font-Poppins-Regular text-[#ff0000]">
                {errors.lastName.message}
              </p>
            )}
          </div>
          <div className="mb-3">
            <Controller
              name="date"
              control={control}
              rules={{ required: "Date of Birth is required" }}
              render={({ field }) => (
                <SimpleInput
                  isLabel={true}
                  labelText="Date of Birth"
                  type="date"
                  id="edit-profile-date-of-birth"
                  extraStyle={{ borderColor: "#00A297", marginBottom: 0 }}
                  {...field}
                  readOnly={true}
                />
              )}
            />
            {errors.date && (
              <p className="font-size-14px font-Poppins-Regular text-[#ff0000]">
                {errors.date.message}
              </p>
            )}
          </div>
          <div className="mb-3 border_hide_and_primary_border">
            <Controller
              name="gender"
              control={control}
              rules={{ required: "Gender is required" }}
              render={({ field }) => (
                <CustomWebsiteDropdown
                  options={genderList}
                  data={genderList.filter((v) => v?.value === field.value)}
                  setData={(e) => field.onChange(e[0]?.value || "")}
                  isMulti={false}
                  labelText="Gender"
                  dropdownMainId="gender-dropdown"
                  readOnly
                />
              )}
            />
            {errors.gender && (
              <p className="font-size-14px font-Poppins-Regular text-[#ff0000]">
                {errors.gender.message}
              </p>
            )}
          </div>
          {/* gender dropdown */}
          <div className="mb-3">
            <Controller
              name="mobile"
              control={control}
              rules={{ 
                required: "Mobile number is required",
                validate: (value) => {
                  if (!value) return "Mobile number is required";
                  
                  const hasPlus = value.startsWith("+");
                  const digitCount = value.replace("+", "").length;
                  
                  if (hasPlus) {
                    if (digitCount < 12) {
                      return "Phone number with + must be 12 digits after + (e.g., +923001234567)";
                    } else if (digitCount > 12) {
                      return "Phone number with + cannot exceed 12 digits after +";
                    }
                  } else {
                    if (digitCount < 11) {
                      return "Phone number must be exactly 11 digits (e.g., 03001234567)";
                    } else if (digitCount > 11) {
                      return "Phone number cannot exceed 11 digits";
                    }
                  }
                  
                  if (!phoneNumberRegex.test(value)) {
                    return "Please enter a valid phone number";
                  }
                  
                  return true;
                }
              }}
              render={({ field }) => (
                <>
                  <SimpleInput
                    isLabel={true}
                    labelText="Contact Number"
                    type="text"
                    id="edit-profile-contact-number"
                    inputMode="numeric" // Suggests a numeric keyboard on mobile devices
                    minLength={11}
                    maxLength={14}
                    extraStyle={{ borderColor: "#00A297", marginBottom: 0 }}
                    placeholder="e.g., 03001234567 or +923001234567"
                    {...field}
                    onChange={(e) => {
                      const { filteredValue } = validateAndFilterPhoneNumber(e);
                      field.onChange(filteredValue);
                    }}
                  />
                  {!errors.mobile && field.value && field.value.length > 0 && (
                    <p className="text-xs text-gray-500 mt-1">
                      {field.value.startsWith("+") 
                        ? "Format: +[country code][number] (12 digits after +, total 13 characters)" 
                        : "Format: [number] (exactly 11 digits)"}
                    </p>
                  )}
                </>
              )}
            />
            {errors.mobile && (
              <p className="font-size-14px font-Poppins-Regular text-[#ff0000]">
                {errors.mobile.message}
              </p>
            )}
          </div>
          <div className="mb-3">
              <Controller
                name="address"
                control={control}
                rules={{ required: "Location is required" }}
                render={({ field }) => (
                  <SimpleInput
                    isLabel={true}
                    labelText="Address"
                    type="text"
                    id="edit-profile-address"
                    extraStyle={{ borderColor: "#00A297", marginBottom: 0 }}
                    {...field}
                  />
                )}
              />
              {errors.address && (
                <p className="font-size-14px font-Poppins-Regular text-[#ff0000]">
                  {errors.address.message}
                </p>
              )}
          </div>
          <div className="">
            {/* <label className="font-Poppins-Regular font-size-16px text-[#252334]">
              City
            </label> */}
            <Controller
              name="city"
              control={control}
              rules={{ required: "City is required" }}
              render={({ field }) => (
                <CustomWebsiteDropdown
                  options={cityList}
                  data={cityList.filter((v) => v?.value === field.value)}
                  setData={(e) => field.onChange(e[0]?.value || "")}
                  isMulti={false}
                  labelText="City"
                  dropdownMainId="city-dropdown"
                  // readOnly={true}
                />
              )}
            />
            {errors.city && (
              <p className="font-size-14px font-Poppins-Regular text-[#ff0000]">
                {errors.city.message}
              </p>
            )}
          </div>
          <hr className="products-tabs-hr-allOrder" />
            {/* Social Links */}
            <h2 className="title-heading font-Poppins-SemiBold font-size-20px mb-4">
              Social Links
            </h2>
            <div className="mb-3">
              <label
                className="font-size-18px font-Poppins-Regular flex items-center gap-2"
                htmlFor=""
              >
                <FontAwesomeIcon
                  className="text-[#00443F]"
                  size="1x"
                  icon={faFacebookSquare}
                />
                Facebook
              </label>
              <Controller
                name="facebookLink"
                control={control}
                rules={{
                  required: false,
                  pattern: {
                    value: /^(https?:\/\/)?(www\.)?facebook\.com(\/.*)?$/,
                    message: "Please enter a valid Facebook link.",
                  },
                }}
                render={({ field }) => (
                  <SimpleInput
                    type="url"
                    placeholder="https://"
                    extraStyle={{ borderColor: "#00A297", marginBottom: 0 }}
                    id="edit-profile-facebook-link"
                    {...field}
                  />
                )}
              />
              {errors.facebookLink && (
                <p className="font-size-14px font-Poppins-Regularpx font-Poppins-Regular text-[#ff0000]">
                  {errors.facebookLink.message}
                </p>
              )}
            </div>
            <div className="mb-3">
              <label
                className="font-size-18px font-Poppins-Regular flex items-center gap-2"
                htmlFor=""
              >
                <FontAwesomeIcon
                  className="text-[#00443F]"
                  size="1x"
                  icon={faInstagram}
                />
                Instagram
              </label>
              <Controller
                name="instagramLink"
                control={control}
                rules={{
                  required: false,
                  pattern: {
                    value: /^(https?:\/\/)?(www\.)?instagram\.com(\/.*)?$/,
                    message: "Please enter a valid Instagram link.",
                  },
                }}
                render={({ field }) => (
                  <SimpleInput
                    type="url"
                    placeholder="https://"
                    extraStyle={{ borderColor: "#00A297", marginBottom: 0 }}
                    id="edit-profile-instagram-link"
                    {...field}
                  />
                )}
              />
              {errors.instagramLink && (
                <p className="font-size-14px font-Poppins-Regularpx font-Poppins-Regular text-[#ff0000]">
                  {errors.instagramLink.message}
                </p>
              )}
            </div>
            <div className="mb-3">
              <label
                className="font-size-18px font-Poppins-Regular flex items-center gap-2"
                htmlFor=""
              >
                <FontAwesomeIcon
                  className="text-[#00443F]"
                  size="1x"
                  icon={faLinkedin}
                />
                LinkedIn
              </label>
              <Controller
                name="linkedinLink"
                control={control}
                rules={{
                  required: false,
                  pattern: {
                    value: /^(https?:\/\/)?(www\.)?linkedin\.com(\/.*)?$/,
                    message: "Please enter a valid LinkedIn link.",
                  },
                }}
                render={({ field }) => (
                  <SimpleInput
                    type="url"
                    placeholder="https://"
                    extraStyle={{ borderColor: "#00A297", marginBottom: 0 }}
                    id="edit-profile-linkedin-link"
                    {...field}
                  />
                )}
              />
              {errors.linkedinLink && (
                <p className="font-size-14px font-Poppins-Regularpx font-Poppins-Regular text-[#ff0000]">
                  {errors.linkedinLink.message}
                </p>
              )}
            </div>
            <div className="mb-3">
              <label
                className="font-size-18px font-Poppins-Regular flex items-center gap-2"
                htmlFor=""
              >
                <FontAwesomeIcon
                  className="text-[#00443F]"
                  size="1x"
                  icon={faWhatsapp}
                />
                WhatsApp
              </label>
              <Controller
                name="whatsappLink"
                control={control}
                rules={{
                  required: false,
                  pattern: {
                    value:
                      /^(https?:\/\/)?(www\.)?(web\.)?whatsapp\.com(\/.*)?$/,
                    message: "Please enter a valid WhatsApp link.",
                  },
                }}
                render={({ field }) => (
                  <SimpleInput
                    type="url"
                    placeholder="https://"
                    extraStyle={{ borderColor: "#00A297", marginBottom: 0 }}
                    id="edit-profile-whatsapp-link"
                    {...field}
                  />
                )}
              />
              {errors.whatsappLink && (
                <p className="font-size-14px font-Poppins-Regularpx font-Poppins-Regular text-[#ff0000]">
                  {errors.whatsappLink.message}
                </p>
              )}
            </div>
          <div className="flex justify-end mt-5">
            <PrimaryBtn
              loader={isLoader}
              type="submit"
              ButtonText="Save"
              btnExtraStyle={{
                backgroundColor: "#00443f",
                borderRadius: "1.5rem",
              }}
              id="edit-profile-save-btn"
            />
          </div>
        </form>
      </div>
    </>
  );
};

export default EditProfile;
